const { default: gql } = require('graphql-tag');

const GET_CONVERSATION = gql`
  query($input: GetConversationsInput!) {
    getConversations(input: $input) {
      conversations {
        conversationId
        type
        content
        data
        failureReason
        conversationStatus
        time
        attachments {
          fileName
          originalFileName
          fileSize
        }
      }
      listInfo {
        page
        pageSize
        condition
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
    }
  }
`;

const GET_ACTIVE_CONVERSATION_THREAD = gql`
  query($input: GetActiveConversationThreadInput) {
    getActiveConversationThread(input: $input) {
      threadId
      displayId
      workItem {
        workId
        module
        displayId
        client {
          name
          accountId
        }
      }
      asset {
        assetId
        name
        assetClass {
          name
          entityName
        }
      }
      status
      recipients {
        initiator {
          user {
            userId
            name
          }
          referenceId
          name
        }
        receiver {
          user {
            userId
            name
          }
          referenceId
          name
        }
      }
      chatActiveSession
    }
  }
`;

const GET_CHAT_TEMPLATES = gql`
  query($input: GetChatTemplatesInput!) {
    getChatTemplatesByConversationThread(input: $input) {
      templateId
      title
      content
      placeholdersUsed
      constant
    }
  }
`;

const GET_NEXT_ID = gql`
  query {
    getNextIdentifier
  }
`;

export {
  GET_ACTIVE_CONVERSATION_THREAD,
  GET_CONVERSATION,
  GET_CHAT_TEMPLATES,
  GET_NEXT_ID
};
